module.exports = __webpack_public_path__ + "img/image19.d761bc23.png";